import React from 'react'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import Error from '../Error/Error'
import Progress from '../Progress/Progress'
import { Notification } from '../Notification/Notification'
import { useCreditCard } from '../CreditCardProvider/CreditCardProvider'

import { SavedCreditCardPicker } from '../SavedCreditCardPicker/SavedCreditCardPicker'

import './CheckoutSavedCreditCard.css'

export const CheckoutSavedCreditCard = ({ field, form, amexAccepted }) => {
  let { creditCards = [], loading, error, refetch } = useCreditCard()
  if (loading) {
    return <Progress eventData={{ category: 'Checkout Saved Card Picker' }} />
  }
  if (error) return <Error error={error} retry={refetch} />

  if (!amexAccepted) {
    creditCards = creditCards.map(card => ({
      ...card,
      guid: card.cardType === 'AMEX' ? `!${card.guid}` : card.guid
    }))
  }

  const currentGuid = getIn(form.values, field.name)
  const currentCard = creditCards.find(({ guid }) => guid === currentGuid) || {}
  const isAmex = currentCard.cardType === 'AMEX'
  const isAmexAndNotAccepted = isAmex && !amexAccepted

  return (
    <React.Fragment>
      <SavedCreditCardPicker creditCards={creditCards} field={field} />
      {isAmexAndNotAccepted && (
        <div styleName='spacer'>
          <Notification>
              Unfortunately, this restaurant does not accept American Express.
              Please use another credit card to complete your order.
          </Notification>
        </div>
      )}
    </React.Fragment>
  )
}

CheckoutSavedCreditCard.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  amexAccepted: PropTypes.bool
}
